import { useContext } from 'react';
import { RouteComponentProps, useParams } from 'react-router';
import { useParameters } from '../../hooks/ParametersHooks';
import { useUserInformations } from '../../hooks/WPHooks';
import { AppContext } from '../../state/AppContextProvider';
import { Modal } from '../globals/Modal';
import { WizardContent } from './WizardContent';

interface WizardProps extends RouteComponentProps {}

const WizardModal: React.FC<WizardProps> = (props: WizardProps) => {
  const { state } = useContext(AppContext);

  const { user, update } = useUserInformations();

  const { updateParameter, parameters } = useParameters(user, update);

  const { slug }: any = useParams();

  const slug2 = slug === undefined ? state.wizardSteps[0] : slug;

  return state.wizardSteps.length > 0 ? (
    <Modal
      contentRender={() => (
        <WizardContent
          currentStep={slug2}
          user={user}
          parameters={parameters}
          updateParameter={updateParameter}
        />
      )}
      ModalUrl={'/wizard'}
      urlMatcher={(modalPath, currentPath) => currentPath.startsWith(modalPath)}
      addClass="fullscreen-modal w-full h-full top-0 left-0 bg-primary z-50 !mr-0"
      backUrl=""
      hideCloseBtn={true}
    ></Modal>
  ) : (
    <>NO data</>
  );
};

export default WizardModal;
